import { AppState, changeStatusSignupModalAction } from "@store";
import * as React from "react";
import { connect, Dispatch } from "react-redux";
import "./LogInPage.css";
import { SvgIcon, ModalWindow, Signup, Notification } from "@components";
import { AAdello, Logo } from "@icons";
import { loginUrl } from "../api/utils";

export interface LogInComponentProps {
    isOpenSignup: boolean;
    onchangeStatusSignupModal: (isOpen: boolean) => void;
}

export interface LogInComponentState {
    loginUrl: string;
}

export class LogInComponent extends React.Component<LogInComponentProps, LogInComponentState> {
    constructor(props: LogInComponentProps) {
        super(props);
        this.state = {
            loginUrl: undefined
        };
    }

    componentWillMount() {
        loginUrl().then(url => this.setState({ loginUrl: url }));
    }

    render() {
        const { isOpenSignup, onchangeStatusSignupModal } = this.props;
        return (
            <div className="login-wrapper">
                <aside className="login_aside-block">
                    <SvgIcon className="login_logo" svg={AAdello} />
                </aside>
                <header className="login_header">
                    <SvgIcon className="login_header_logo" svg={Logo} />
                </header>
                <main className="login_main-block">
                    <section className="login_banner-block">
                        <div className="banner_newsletter-block">
                            <h3 className="banner_newsletter-title">Don’t have an account yet?</h3>
                            <p className="banner_newsletter-text">
                                Adello Direct allows you to Create, Track and Monitor your campaigns.
                                <span className="banner_newsletter-enter" />
                                Sign up to our newsletter and stay updated.
                            </p>
                            <button
                                onClick={() => onchangeStatusSignupModal(true)}
                                className="common-btn important banner_newsletter-btn"
                            >
                                Sign up to our newsletter
                            </button>
                        </div>
                        <div className="banner_registration-block">
                            <h2 className="banner_registration-title">Login with email</h2>
                            <a className="common-btn important banner_registration-btn" href={this.state.loginUrl}>
                                Login
                            </a>
                        </div>
                        <div className="banner_empty-block" />
                    </section>
                </main>
                <ModalWindow modalId="createSignupPopup" state={isOpenSignup} transition={true}>
                    <Signup />
                </ModalWindow>
                <Notification />
                {/* <Support /> */}
            </div>
        );
    }
}

export interface LogInPageProps {}

export const LogInPage = connect(
    (state: AppState, ownProps: LogInPageProps) => {
        return {
            isOpenSignup: state.signupState.isOpenSignup
        };
    },
    (dispatch: Dispatch, ownProps: LogInPageProps) => ({
        onchangeStatusSignupModal: (isOpen: boolean) => {
            dispatch(changeStatusSignupModalAction({ isOpen: isOpen }));
        }
    })
)(LogInComponent);
